export default __webpack_public_path__ + "static/media/product_description_rewriter.6f0ff126.svg";